import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ContractHandler } from '../../../scripts/contracts/contract-handler';
import { DateHandler } from '../../../scripts/date-handler';
import { ExtDocument } from '../../../scripts/extDocument';
import { DatahubService } from '../../../services/datahub.service';

@Component({
  selector: 'app-modal-content-timesheet-select',
  templateUrl: './modal-content-timesheet-select.component.html',
  standalone: false,
})
export class ModalContentTimesheetSelectComponent implements OnInit {
  @Input() public step!: number;
  @Input() public handler?: DateHandler;
  @Input() public contract!: ContractHandler;
  @Input() public timesheets: ExtDocument[] = [];

  @Output() public readonly closed = new EventEmitter<ExtDocument>();

  public isSearching = false;

  constructor(private readonly datahub: DatahubService) {}

  ngOnInit(): void {
    if (this.handler) {
      this.handler = new DateHandler(this.handler.getSapDateString());
    } else {
      this.handler = new DateHandler();
      this.handler.setDate(this.handler.getWeDate());
    }

    if (this.step === 1) this.search();
  }

  select(element: ExtDocument) {
    if (element.isForeign) {
      this.datahub.messageService.warning(
        `You do not own the "<strong>${element.display}</strong>" timesheet. You cannot edit, approve, or add to its time.`,
      );
      return;
    }
    this.closed.emit(element);
  }

  close() {
    this.closed.emit(null);
  }

  goToContractSelect() {
    this.step = 1;
  }

  goToTimesheetSelect(contract: ContractHandler) {
    this.contract = contract;
    this.search();
    this.step = 2;
  }

  makeNewTimesheet() {
    this.datahub.navigate('timesheetmanager');
    this.close();
  }

  search() {
    this.isSearching = true;
    this.datahub.apiService
      .getTimesheets$({
        Dateentered: this.handler.getFilterString(),
        Salesdoc: this.contract.value.ServiceOrder,
      })
      .subscribe({
        next: (timesheets) => {
          this.isSearching = false;
          this.timesheets = timesheets.map((x) => new ExtDocument(x, this.datahub, false));
        },
        error: () => (this.isSearching = false),
      });
  }
}
